import React, { useState, useRef, useEffect } from "react";
import { UserProfile } from "../../types";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faDesktop, faHome, faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { getAppStyles } from "../../theme/app-theme";
import "./styles.scss";

interface UserBadgeProps {
    user: UserProfile;
    propStyles?: Object;
    isDarkMode?: boolean;
}

const UserBadge: React.FC<UserBadgeProps> = ({
    user,
    propStyles,
    isDarkMode = false,
}) => {
    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const { logout, featureToggles } = useAuth();
    const location = useLocation();
    const themeStyles = getAppStyles(isDarkMode);

    useEffect(() => {
        setOpen(false);
    }, [location]);

    const initials = user.name
        .split(" ")
        .map((n) => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div style={{ ...styles.container, ...propStyles }} ref={menuRef}>
            <div
                style={{
                    ...styles.badge,
                    color: isDarkMode ? "#e8e9f4" : undefined,
                }}
                onClick={() => setOpen(!open)}
            >
                <div style={styles.circle}>{initials}</div>
                <span className="user-name">{user.name}</span>
                <span style={{ marginLeft: 6 }}><FontAwesomeIcon icon={faChevronDown} /></span>
            </div>

            {open && (
                <div style={themeStyles.menu}>
                    {location.pathname !== "/painel-central/dashboard" && (
                        <div
                            style={themeStyles.menuItem}
                            onClick={() => navigate("/painel-central/dashboard")}
                        >
                            <FontAwesomeIcon icon={faHome} /> Home
                        </div>
                    )}

                    {featureToggles.filter(obj => obj.nome === "Painel Admin").length > 0 && (
                        <div
                            style={themeStyles.menuItem}
                            onClick={() => navigate("/painel-central/admin-panel")}
                        >
                            <FontAwesomeIcon icon={faDesktop} /> Painel administrativo
                        </div>
                    )}

                    <div style={themeStyles.menuItem} onClick={logout}>
                        <FontAwesomeIcon icon={faPowerOff} /> Sair
                    </div>
                </div>
            )}
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    container: {
        position: "relative",
        display: "inline-block",
    },
    badge: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        padding: "4px 8px",
        borderRadius: "6px",
        transition: "background 0.2s",
    },
    circle: {
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        backgroundColor: "#ED1C24",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "14px",
    },
};

export default UserBadge;
